<div class="@container" data-test-id="availability-widget">
	<div class="card card-no-padding card-elevation-5">
		@if (showAccommodationTypes() && accommodationTypes()?.length > 1) {
			<vp-tab-menu
				[refreshToken]="tabMenuRefreshToken"
				[(activeTab)]="activeAccommodationTypeIndex"
				color="white"
			>
				<vp-tab-menu-item
					[label]="('global.all' | translate) || 'All'"
					[name]="'all'"
				/>
				@for (item of accommodationTypes(); track $index) {
					<vp-tab-menu-item
						[label]="item.name"
						[name]="item.accommodationType"
					/>
				}
			</vp-tab-menu>
		}
		<div class="card-inner-md flex flex-col gap-4 @lg:flex-row">
			<div class="empty:hidden @md:hidden" data-test-id="slot">
				<ng-content />
			</div>
			<div class="flex size-full flex-col @sm:flex-row children:flex-1">
				@if (sortedHotels()) {
					<vp-availability-widget-input-dropdown
						[className]="
							cn(
								'focus:relative focus:z-10',
								(showPackages() ||
									showOccupancy() ||
									showDates()) &&
									'@max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[isOpen]="isHotelsOpen()"
						[items]="sortedHotels()"
						[label]="'global.hotel.label' | translate"
						[placeholder]="
							'global.hotel-selection-placeholder' | translate
						"
						[searchable]="true"
						(emitCta)="onCtaEmit($event, nextInputAfterHotel())"
						(isOpenChange)="onInputOpenChange('hotels', $event)"
						(itemSelected)="onHotelSelect($event)"
						data-test-id="hotels-selector"
						inputName="availability-hotels"
					/>
				}
				@if (showOccupancy() && occupancyRestrictions()) {
					<vp-availability-widget-input-occupancy
						[className]="
							cn(
								'focus:relative focus:z-10',
								showHotels() &&
									'@max-sm:rounded-t-none @sm:rounded-l-none',
								(showPackages() || showDates()) &&
									'@max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[ctaLabel]="
							hasMultiplePackages()
								? 'global.choose-package'
								: 'global.choose-dates'
						"
						[defaultAdults]="defaultAdults"
						[initialOccupancy]="initialOccupancy"
						[isOpen]="isOccupancyOpen()"
						[maxRooms]="
							activeOccupancyRestrictions().maxOccupancies
						"
						[occupancyRestrictions]="activeOccupancyRestrictions()"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								false,
								false,
								false
							)
						"
						(emitCta)="onCtaEmit($event, nextInputAfterOccupancy())"
						(isOpenChange)="onOccupancyOpenEmit($event)"
						(occupancyChanged)="onOccupancyEmit($event)"
						data-test-id="occupancy-selector"
					/>
				}
				@if (showPackages() && packages()?.length > 0) {
					<vp-availability-widget-input-dropdown
						[className]="
							cn(
								'focus:relative focus:z-10',
								(showHotels() || showOccupancy()) &&
									'@max-sm:rounded-t-none @sm:rounded-l-none',
								showDates() &&
									'@max-sm:-mb-px @max-sm:rounded-b-none @sm:-mr-px @sm:rounded-r-none'
							)
						"
						[isOpen]="isPackagesOpen()"
						[items]="packages()"
						[label]="'global.package-label' | translate"
						[placeholder]="
							'global.package-selection-placeholder' | translate
						"
						[(selectedItem)]="selectedPackage"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								showOccupancy(),
								false,
								false
							)
						"
						(emitCta)="onCtaEmit($event)"
						(isOpenChange)="onInputOpenChange('packages', $event)"
						(itemSelected)="onPackageSelect($event)"
						data-test-id="package-selector"
						inputName="availability-packages"
					/>
				}
				@if (showDates()) {
					<vp-availability-widget-input-date-range
						[availability]="availability$ | async"
						[bookingtoolHref]="bookingtoolHref()"
						[bookingtoolQuery]="bookingtoolQuery()"
						[className]="
							cn(
								'focus:md:border-l',
								(showPackages() ||
									showHotels() ||
									showOccupancy()) &&
									'@max-sm:rounded-t-none @sm:rounded-l-none'
							)
						"
						[config]="{
							mode: 'range',
							showMonths: 2,
							minDate: effectiveMinDate(),
							maxDate: effectiveMaxDate(),
						}"
						[ctaDisabled]="isCtaDisabled()"
						[currency]="activeHotelCurrency()"
						[hideRangePrices]="forceHideRangePrices()"
						[initialArrivalDate]="initialArrivalDate"
						[initialDepartureDate]="initialDepartureDate"
						[isExternalUrl]="isExternalUrl()"
						[isLoading]="isLoading"
						[isOpen]="isDatePickerOpen()"
						[jumpToFirstAvailableDate]="jumpToFirstAvailableDate"
						[numberOfNights]="
							(showPackages() && selectedPackage()?.nights) ||
							(stepperConfig?.useStepper && nights)
						"
						[resetDateRange]="_resetDateRange"
						[showPrices]="showPrices()"
						[stepperConfig]="stepperConfig"
						(datePickerModelChanged)="updateModel($event)"
						(emitAvailabilityButton)="onCtaClick($event)"
						(emitBackButton)="
							onBackButton(
								$event,
								showHotels(),
								hasMultiplePackages() ? false : showOccupancy(),
								hasMultiplePackages(),
								false
							)
						"
						(emitIsPopoverOpen)="onDatePickerOpened($event)"
						(emitMonthChange)="onMonthChange($event)"
						(initialDatesNotAvailable)="
							recalculateAvailabilityForToday()
						"
						(stepperUpdated)="onStepperUpdated($event)"
						data-test-id="dates-selector"
					/>
				}
			</div>
			@if (
				isExternalUrl() ||
				useLocalizedBookingRoute() ||
				isVhiHotelSelected()
			) {
				<a
					[attr.aria-disabled]="isCtaDisabled() ? true : false"
					[attr.href]="ctaHref()"
					[attr.tabindex]="isCtaDisabled() ? -1 : null"
					[class]="
						cn(
							'btn btn-primary w-full text-center @md:h-auto @lg:w-fit',
							isCtaDisabled() && 'btn-disabled'
						)
					"
					[target]="openAvailabilityInNewTab() ? '_blank' : '_self'"
					(click)="onCtaClick($event)"
					data-test-id="cta-button"
				>
					{{ 'global.show-availability' | translate }}
				</a>
			} @else {
				<a
					[attr.aria-disabled]="isCtaDisabled() ? true : null"
					[attr.tabindex]="isCtaDisabled() ? -1 : null"
					[class]="
						cn(
							'btn btn-primary w-full text-center @md:h-auto @lg:w-fit',
							isCtaDisabled() && 'btn-disabled'
						)
					"
					[queryParams]="bookingtoolQuery()"
					[queryParamsHandling]="'merge'"
					[routerLink]="routerLink()"
					(click)="onCtaClick($event)"
					data-test-id="cta-button"
				>
					{{ 'global.show-availability' | translate }}
				</a>
			}
		</div>
	</div>
</div>
